module.exports = __webpack_public_path__ + "static/media/eli_on.0e3ec146.png";